<template>
  <div>
    <div class="bottom_img" style="position: relative;" >
      <img style="width:100%;height:50vh" v-if="solutionlist.position1.length > 0" :src="solutionlist.position1[0].thumb" />
      <p v-if="false" style="position: absolute;
              color: #fff;
              bottom: 10vh;
              font-size: 6vh;
              left: 12%;
              border-bottom: 2px solid #ccc;
              font-weight: 600;">{{ solutionlist.position1[0].title }}</p>
    </div>
    <div class="bbox" v-if="solutionlist.position2.length > 0">
      <div class="row max_box" style="">
        <div class="col-lg-6">
          <div>
            <img class="bg-style" :src="solutionlist.position2[0].thumb" />
          </div>
        </div>
        <div class="col-lg-6" v-if="solutionlist.position2.length > 1">
          <div class="box_name">
            <h3 class="h1_title">{{ solutionlist.position2[1].title }}</h3>
            <div class="bor_bottom"></div>
            <p class="p_box_width">
              {{ solutionlist.position2[1].brief }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="col-img-height" style="margin-bottom: 20px;" v-if="solutionlist.position3.length > 0">
      <div class="row">
        <!-- col-img -->
        <div class="col-lg-2 p-r" style="cursor: pointer;" v-for="(item, index) in solutionlist.position3" :key="index"
          @mouseover="mouseOver(item)" @mouseleave="mouseLeave(item)" @click="openDetail(item)">
          <div v-if="index < 6">
            <img :src="item.thumb" class="p-r-img" style="width: 100%; height: 60vh; border: 1px solid #fff;" alt="">
            <div class="p-a-lable">
              <span style="background: #f8b600; padding-top: 5px; padding-bottom: 5px;">{{ item.title }}</span>
            </div>
            <div v-show="item.status1" class="p-a">
              <h2 style="width:100%;text-align: center;color: #fff;margin-top: 30px;font-size: 2vh;">{{ item.title }}</h2>
              <p style="font-size: 12px;padding: 10px; white-space: pre-wrap;">{{ item.brief }}</p>
            </div>
          </div>

        </div>
      </div>
    </div>
    <div class="bbox-top" v-if="solutionlist.position4.length > 0">
      <div class="row max_box" style="">
        <div class="col-lg-6">
          <div class="bbox-top_name" v-if="solutionlist.position4[0] != undefined">
            <h3 class="h1_title">{{ solutionlist.position4[0].title }}</h3>
            <div class="bor_bottom"></div>
            <p class="p_box_width">
              {{ solutionlist.position4[0].brief }}
            </p>
          </div>
        </div>
        <div class="col-lg-6 ">
          <div class="bbox-top-bg-style" v-if="solutionlist.position4[0] != undefined">
            <img style="width:100%;min-height: 36vh;" :src="solutionlist.position4[0].thumb" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import axios from "axios";

export default {
  props: ['list'],
  data() {
    return {
      image: [
        { src: 'http://www.battery-doctor.cn/statics/web/upimg/lnpt_04.jpg', lable: '绿色储能', title: '知安云1', status: false, name: '绿电来操作系统是美克生开发的一套面向新型电力系统的数字孪生平台，它基于物联网、边缘计算、云计算、移动计算、大数据、人工智能、区块链等众多new ICT技术， 不仅涵盖新能源发电、配电、用电、电化学储能、充电等设备；更可对源网荷储充协同优化、电力交易、绿电认证等进行分析；也可以对电池簇、电池箱和电芯单体进行三个层级的健康状态诊断、预测，并给出优化运维策略。 3D、互动网页展示，支持新型电力系统的规划设计、建造、运营、运维等全业务流程的闭环管理，为客户带来降本、增效、提质和绿色论证的价值创造。' },
        { src: 'http://www.battery-doctor.cn/statics/web/upimg/lnpt_03.jpg', lable: '智能充电', title: '知安云2', status: false, name: '绿电来操作系统是美克生开发的一套面向新型电力系统的数字孪生平台，它基于物联网、边缘计算、云计算、移动计算、大数据、人工智能、区块链等众多new ICT技术， 不仅涵盖新能源发电、配电、用电、电化学储能、充电等设备；更可对源网荷储充协同优化、电力交易、绿电认证等进行分析；也可以对电池簇、电池箱和电芯单体进行三个层级的健康状态诊断、预测，并给出优化运维策略。 3D、互动网页展示，支持新型电力系统的规划设计、建造、运营、运维等全业务流程的闭环管理，为客户带来降本、增效、提质和绿色论证的价值创造。' },
        { src: 'http://www.battery-doctor.cn/statics/web/upimg/lnpt_03.jpg', lable: '智慧家电', title: '知安云3', status: false, name: '绿电来操作系统是美克生开发的一套面向新型电力系统的数字孪生平台，它基于物联网、边缘计算、云计算、移动计算、大数据、人工智能、区块链等众多new ICT技术， 不仅涵盖新能源发电、配电、用电、电化学储能、充电等设备；更可对源网荷储充协同优化、电力交易、绿电认证等进行分析；也可以对电池簇、电池箱和电芯单体进行三个层级的健康状态诊断、预测，并给出优化运维策略。 3D、互动网页展示，支持新型电力系统的规划设计、建造、运营、运维等全业务流程的闭环管理，为客户带来降本、增效、提质和绿色论证的价值创造。' },
        { src: 'http://www.battery-doctor.cn/statics/web/upimg/lnpt_04.jpg', lable: '智能交通', title: '知安云4', status: false, name: '绿电来操作系统是美克生开发的一套面向新型电力系统的数字孪生平台，它基于物联网、边缘计算、云计算、移动计算、大数据、人工智能、区块链等众多new ICT技术， 不仅涵盖新能源发电、配电、用电、电化学储能、充电等设备；更可对源网荷储充协同优化、电力交易、绿电认证等进行分析；也可以对电池簇、电池箱和电芯单体进行三个层级的健康状态诊断、预测，并给出优化运维策略。 3D、互动网页展示，支持新型电力系统的规划设计、建造、运营、运维等全业务流程的闭环管理，为客户带来降本、增效、提质和绿色论证的价值创造。' },
        { src: 'http://www.battery-doctor.cn/statics/web/upimg/lnpt_03.jpg', lable: '智能充电', title: '知安云5', status: false, name: '绿电来操作系统是美克生开发的一套面向新型电力系统的数字孪生平台，它基于物联网、边缘计算、云计算、移动计算、大数据、人工智能、区块链等众多new ICT技术， 不仅涵盖新能源发电、配电、用电、电化学储能、充电等设备；更可对源网荷储充协同优化、电力交易、绿电认证等进行分析；也可以对电池簇、电池箱和电芯单体进行三个层级的健康状态诊断、预测，并给出优化运维策略。 3D、互动网页展示，支持新型电力系统的规划设计、建造、运营、运维等全业务流程的闭环管理，为客户带来降本、增效、提质和绿色论证的价值创造。' },
        { src: 'http://www.battery-doctor.cn/statics/web/upimg/lnpt_05.jpg', lable: '智慧家电', title: '知安云6', status: false, name: '绿电来操作系统是美克生开发的一套面向新型电力系统的数字孪生平台，它基于物联网、边缘计算、云计算、移动计算、大数据、人工智能、区块链等众多new ICT技术， 不仅涵盖新能源发电、配电、用电、电化学储能、充电等设备；更可对源网荷储充协同优化、电力交易、绿电认证等进行分析；也可以对电池簇、电池箱和电芯单体进行三个层级的健康状态诊断、预测，并给出优化运维策略。 3D、互动网页展示，支持新型电力系统的规划设计、建造、运营、运维等全业务流程的闭环管理，为客户带来降本、增效、提质和绿色论证的价值创造。' }
      ],
      solutionlist: {
        position1: [],
        position2: [],
        position3: [],
        position4: [],
      },
    }
  },
  mounted() {
    this.getus(this.$route.query.id)
  },
  methods: {
    mouseOver(item) {
      item.status1 = true
    },
    mouseLeave(item) {
      item.status1 = false
    },
    openDetail(item) {
      window.open("/detail?id=" + item.id, "_black")
    },
    getus(id) {
      axios.get('http://cms.saveus.cn/api/ttg/page?id=' + id).then(res => {
        let list = res.data.data;
        for (let index = 0; index < list.length; index++) {
          if (list[index].position == 1) {
            this.solutionlist.position1.push(list[index])
          } else if (list[index].position == 2) {
            this.solutionlist.position2.push(list[index])
          } else if (list[index].position == 3) {
            list[index].status1 = false
            this.solutionlist.position3.push(list[index])
          } else if (list[index].position == 4) {
            this.solutionlist.position4.push(list[index])
          }
        }
      })
    },
  },
}
</script>
<style  scoped>
.row {
  display: flex;
  justify-content: center;
  margin-right: 0px !important;
  margin-left: 0px !important;
}

/* 最小 */
@media (min-width: 280px) and (max-width: 768px) {
  .bottom_img {
    height: 50vh;
    /* background:url(/static/assets/images/jiejuefangan.png);
    background-size: 100% 100%;
    background-repeat: no-repeat; */
  }
  .bbox {
    height: auto;
    display: flex;
    align-items: center;
  }
  .row {
    cursor: pointer;
    padding-right: 0px !important;
    padding-left: 0px !important;
  }
  .col-lg-2 {
    padding-right: 0px !important;
    padding-left: 0px !important;
  }

  .col-lg-6:nth-child(1) {
    padding-right: 0px !important;
    padding-left: 0px !important;
  }

  .col-lg-6:nth-child(2) {
    padding-right: 0px !important;
    padding-left: 0px !important;
    padding: 6px;
  }
  .bbox-top {
    height: 50v !important;
    display: flex;
    flex-direction: row;
    align-content: center;
    justify-content: center;
    align-items: center;

  }
  .h1_title {
    text-align: center;
  }
  .img_box {
    width: 100% !important;
    height: auto;
  }
  .box_name {
    height: 40vh;
    /* text-align: none; */
  }
  .p_box_width {
    padding: 10px;
    width: 100%;
    height: 30vh;
    font-size: 2vh;
  }
  .bor_bottom {
    display: none;
    width: 70px;
    border-bottom: 6px solid blueviolet;
    margin: 0 81px;
  }
  .bg-style {
    border-top: 1px solid #fff;
    background-size: 100%;
    /* background-image: url('../../static/assets/images/lnpt_02.jpg'); */
    width: 100%;
    height: 40vhpx;
    margin: 0 auto;
    background-repeat: no-repeat;
  }
  .col-img-height {
    height: auto;
  }
  .col-img {
    padding: 1px;
    width: 100%;
    margin: 0 auto;
    height: 100vh;
    border: 1px solid #fff;
  }
  .p-a {
    color: #fff;
    position: absolute;
    top: 0px;
    height: 100%;
    width: 100%;
    background-color: rgba(32, 57, 100, 1);
    border: 1px solid #fff;

  }
  .p-r .p-r-img {
    position: relative;
  }
  .p-a-lable {
    width: 100%;
    color: #fff;
    height: 100%;
    position: absolute;
    font-weight: 600;
    bottom: 0px;
    font-size: 2vh;
    -ms-writing-mode: tb-rl;
    writing-mode: vertical-rl;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-direction: row;
    flex-direction: row;
    -ms-flex-wrap: nowrap;
    flex-wrap: nowrap;
    -ms-flex-line-pack: justify;
    align-content: space-between;
    -ms-flex-align: center;
    align-items: center;
    justify-content: center;
  }
  .bbox-top-bg-style {
    /* background: url('../../static/assets/images/lnpt_02.jpg'); */
    /* background: url('../../static/assets/images/Snipaste_2022-06-10_17-06-30.png'); */

    background-size: 100% 100%;
    background-repeat: no-repeat;
    width: 100%;
    height: 36vh;
  }

  .bbox-top-bg-style>img {
    height: 36vh;

  }
}

/* 最大 */
@media (min-width: 1200px) {
  .bottom_img {
    height: 50vh;
    /* background:url(/static/assets/images/jiejuefangan.png);
    background-size: 100% 100%;
    background-repeat: no-repeat; */

  }

  .col-lg-2 {
    padding-right: 0px !important;
    padding-left: 0px !important;
  }

  .bbox {
    height: 50vh;
    display: flex;
    flex-direction: column;
    justify-content: center;

  }

  .max_box {
    padding: 10px;
    /* height: 50%; */
  }

  .bg-style {
    /* background: url('../../static/assets/images/lnpt_02.jpg'); */
    background-size: 100% 100%;
    background-repeat: no-repeat;
    width: 80%;
    height: 100%;
    /* margin: 0 auto; */
    float: right;
  }

  .h1_title {
    width: 95%;
    margin: 5px auto;
    text-align: left;

  }

  .box_name {
    width: 70%;
    height: 200px;
    background: #fff;
    border-top: 4px solid;
    height: 100%;
    border-radius: 5px;
    margin-left: -2px;
    box-shadow: 10px 10px 10px 10px rgba(0.5, 0.5, 0.5, 0.5);
    -moz-box-shadow: 10px 10px 10px 10px rgba(0.5, 0.5, 0.5, 0.5);
    -webkit-box-shadow: 10px 10px 10px 10px rgba(0.5, 0.5, 0.5, 0.5);
    /* display: flex;
    flex-direction: column;
    align-items: baseline;
    justify-content: space-evenly; */
  }

  .p_box_width {
    width: 95%;
    margin: 5px auto;
  }

  .bor_bottom {
    display: block;
    width: 70px;
    border-bottom: 6px solid blueviolet;
    margin: 0 14px;
  }

  .col-img-height {
    height: 60vh;
  }

  .col-img {
    padding: 1px;
    border: 1px solid #fff;
  }

  .p-r .p-r-img {
    position: relative;
  }

  .p-a {
    color: #fff;
    position: absolute;
    top: 0px;
    height: 100%;
    width: 100%;
    padding: 6px;

    position: absolute;
    background-color: rgba(32, 57, 100, 1);
    border: 1px solid #fff;
  }

  .p-a-lable {
    /* width: 100%;
    color: #fff;
    position: absolute;
    top: 34%;
    font-weight: 600;
    font-size: 28px;
    -webkit-writing-mode: vertical-rl;
    writing-mode: vertical-rl;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-content: space-between;
    align-items: center; */

    width: 100%;
    color: #fff;
    height: 100%;
    position: absolute;
    font-weight: 600;
    bottom: 0px;
    font-size: 2vh;
    /* margin-top: 30px; */
    -ms-writing-mode: tb-rl;
    writing-mode: vertical-rl;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-direction: row;
    flex-direction: row;
    -ms-flex-wrap: nowrap;
    flex-wrap: nowrap;
    -ms-flex-line-pack: justify;
    align-content: space-between;
    -ms-flex-align: center;
    align-items: center;
    justify-content: center;
  }


  .bbox-top {
    height: 60vh;
    display: flex;
    flex-direction: row;
    align-content: center;
    justify-content: center;
    align-items: center;

  }

  .bbox-tops {
    width: 80%;
    border: 1px solid;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-content: flex-end;
    align-items: center;
  }

  .bbox-top_name {
    width: 70%;
    /* height: 60vh; */
    background: #fff;
    /* height: 100%; */
    border-radius: 5px;
    /* margin: 0 auto; */
    min-height: 36vh;
    float: right;
    box-shadow: 10px 10px 10px 10px rgba(0.5, 0.5, 0.5, 0.5);
    -moz-box-shadow: 10px 10px 10px 10px rgba(0.5, 0.5, 0.5, 0.5);
    -webkit-box-shadow: 10px 10px 10px 10px rgba(0.5, 0.5, 0.5, 0.5);

  }

  .bbox-top-bg-style {
    /* background: url('../../static/assets/images/Snipaste_2022-06-10_17-06-30.png'); */
    /* background-size: 100% 100%; */
    /* background-repeat: no-repeat; */
    width: 80%;
    /* height: 100%; */
    /* margin: 0 auto; */
  }

  .bbox-top-bg-style>img {
    height: 36vh;

  }
}

/* Snipaste_2022-06-10_17-06-30 */
</style>



// WEBPACK FOOTER //
// Product.vue?4d96ca90